document.addEventListener("DOMContentLoaded", function () {
    // Open modal
    document.querySelectorAll("[data-modal]").forEach(opener => {
      opener.addEventListener("click", function () {
        const modalId = this.getAttribute("data-modal");
        const modal = document.getElementById(modalId);
        if (modal) {
          modal.setAttribute("open", ""); // Ensure the open attribute is present
          modal.classList.remove("hidden");
        }
      });
    });

  // Close modal when clicking the close button
document.querySelectorAll(".js-close-modal").forEach(btn => {
  btn.addEventListener("click", function () {
    const modal = this.closest(".modal.hsn__search-model");
    if (modal) {
      modal.classList.add("hidden");
      modal.removeAttribute("open");
    }
  });
});

    document.querySelectorAll('.modal__close-button').forEach(button => {
      button.addEventListener('click', function () {
        const details = button.closest('details');
        if (details && details.hasAttribute('open')) {
          details.removeAttribute('open');
        }
      });
    });

    // Optional: close when clicking outside modal content
    document.querySelectorAll("modal-dialog").forEach(modal => {
      modal.addEventListener("click", function (e) {
        if (e.target === modal) {
          modal.classList.add("hidden");
          modal.removeAttribute("open");
        }
      });
    });
  });